import { render } from "./Torneo1.vue?vue&type=template&id=1b1af158"
import script from "./Torneo1.vue?vue&type=script&lang=js"
export * from "./Torneo1.vue?vue&type=script&lang=js"
script.render = render

export default script